import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IconButton from '../ui/IconButton';
import Button from '../ui/Button';
import LanguageToggle from '../ui/LanguageToggle';
import NotificationsDrawer from './NotificationsDrawer';
import { useT } from '../../i18n/LocaleContext';
import { useAuth } from '../../contexts/AuthContext';

export default function Topbar({ title, subtitle, isMobile, onOpenMenu }) {
  const t = useT();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <div style={{
        background: 'var(--white)',
        borderBottom: '1px solid var(--border)',
        padding: isMobile ? '0 14px' : '0 28px',
        minHeight: '62px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '10px',
        boxShadow: '0 1px 0 var(--border)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0 }}>
          {isMobile && (
            <IconButton onClick={onOpenMenu} ariaLabel={t('common.open_menu')}>☰</IconButton>
          )}
          <div style={{ minWidth: 0 }}>
            <div style={{
              fontFamily: "'Cinzel', serif",
              fontSize: isMobile ? '14px' : '17px',
              color: 'var(--blue-deep)',
              letterSpacing: '0.5px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}>{title}</div>
            {!isMobile && subtitle && (
              <div style={{
                fontFamily: "'EB Garamond', serif",
                fontStyle: 'italic',
                fontSize: '12px',
                color: 'var(--text-muted)',
              }}>{subtitle}</div>
            )}
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <LanguageToggle compact />
          <IconButton ariaLabel={t('notifications.title')} onClick={() => setDrawerOpen(true)}>
            🔔
            <span className="dot" />
          </IconButton>
          {!isMobile && hasPermission('members:create') && (
            <Button variant="ghost" onClick={() => navigate('/members?new=1')}>
              + {t('dashboard.new_member')}
            </Button>
          )}
          {hasPermission('payments:create') && (
            <Button
              variant="gold"
              onClick={() => navigate('/payments?new=1')}
            >
              {isMobile ? `+ ${t('payments.short_label')}` : `+ ${t('dashboard.record_payment')}`}
            </Button>
          )}
        </div>
      </div>

      <NotificationsDrawer isOpen={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </>
  );
}
